import { useQuery } from '@tanstack/react-query';
import { DocumentService } from '../../services/document';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IDocumentResponse } from '../../interfaces/documentResponse';

interface IProps extends IBaseUseQueryProps<IDocumentResponse[]> {
  customerId: number | null;
}

export const GET_CUSTOMER_DOCS_QUERY_KEY = 'get-customer-docs';

export const useGetCustomerDocuments = ({ customerId, ...props }: IProps) => useQuery({
  queryKey: [GET_CUSTOMER_DOCS_QUERY_KEY, customerId],
  queryFn: () => DocumentService.getCustomerDocuments(customerId as number),
  refetchOnWindowFocus: false,
  enabled: customerId !== null,
  ...props
});